const MAINTENANCE_BYPASS_STORAGE_KEY = 'maintenance-bypass-v1';
const MAINTENANCE_BYPASS_QUERY_PARAM = 'maintenance-bypass';
const MAINTENANCE_BYPASS_VALUE = 'parkapp-team-access';

export const hasMaintenanceBypass = (): boolean =>
  window.localStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY)?.trim() === MAINTENANCE_BYPASS_VALUE;

/**
 * Reads the maintenance bypass value from the current URL
 * (`/?maintenance-bypass=parkapp-team-access`) and persists it so team members
 * can keep using the app while the maintenance lock is on. Safe to call on
 * every app load, also before a maintenance window starts.
 */
export const captureMaintenanceBypassFromUrl = (): void => {
  const params = new URLSearchParams(window.location.search);
  const bypassValue = params.get(MAINTENANCE_BYPASS_QUERY_PARAM)?.trim();
  if (bypassValue) {
    window.localStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, bypassValue);
  }
};
